import { styled } from '@styledComponents';
import { ECard } from '@components/ECard';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';

export const skewHWRatio = 0.3;
export const SectionBox = styled(Box)`
  position: relative;
  height: 100vh;
  width: 100vw;
`;

export const MainTextPairing = styled(TextPairing)`
  .text-pairing-title,
  .text-pairing-body {
    max-width: 380px;
  }
`;

export const MultipleTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
  .text-pairing-title {
    max-width: 380px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      max-width: 260px;
    }
    ${themeMediaQuery('xl')} {
      max-width: 490px;
    }
  }
  .text-pairing-body {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
`;

export const SpreadSheetTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      max-width: 320px;
    }
    max-width: 295px;
    ${themeMediaQuery('xl')} {
      max-width: 415px;
    }
  }
  .text-pairing-body {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
`;

export const SpreadsheetCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    margin: ${themeSpace(6)} 0px;
    width: 100%;
    height: 100%;
  }
`;

export const SpreadsheetColumns = styled(Columns)`
  direction: rtl;
  ${themeMediaQuery('below_sm')} {
    direction: ltr;
  }
`;

export const SpreadsheetColumn = styled(Columns.Column)`
  direction: ltr;
`;

export const ECardContainer = styled(Flex)`
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 70vh;
`;

export const StyledECard = styled(ECard)`
  height: 100%;
`;

export const FirstInvitationContainer = styled(Box)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const AnimationContainer = styled(Box)`
  width: 100%;
`;

export const EdiitingGuestListWrapper = styled(Box)`
  position: relative;
  margin-top: -14vw;

  ${themeMediaQuery('below_sm')} {
    margin-top: -120px;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 59%;
  height: 100%;
`;

export const StyledBox = styled(Box)`
  position: relative;
`;

export const ImportButtonBox = styled(Box)`
  position: absolute;
  top: 38%;
  left: 29%;
`;

export const MultipleEditorBox = styled(Box)`
  position: absolute;
  top: 7%;
  right: 29%;
`;

export const EditorsCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    margin: ${themeSpace(6)} 0px;
    width: 100%;
    height: 100%;
  }
`;

export const StyledCursorsCloudImage = styled(CloudImage)`
  width: 100%;
  height: 100%;
`;
